import(/* webpackMode: "eager" */ "/var/app/admin-portal/app/page.tsx")